import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AlertInterface } from '../type/alert-info.interface';


@Injectable({
  providedIn: 'root',
})
export class AlertInfoService {
  private alert$ = new Subject<AlertInterface>();

  setAlert(alert: AlertInterface): void {
    this.alert$.next(alert);
  }

  getAlert(): Observable<AlertInterface> {
    return this.alert$.asObservable();
  }
}
